import { TypographyV3 } from '@jouzen/ecom-components';
import { useTranslations } from 'next-intl';
import type { MessageKey } from 'types/LocaleMessageKey';

import Image from '@/app/components/Image';

interface Image {
  alt: string;
  src: string;
  className: string;
}

interface Accolades {
  id: number;
  image: Image;
  content: MessageKey;
}

const ACCOLADES_DATA: Accolades[] = [
  {
    id: 0,
    image: {
      alt: 'Time',
      src: 'product-accolades/time-color-logo',
      className: 'h-8',
    },
    content: 'accolades_time',
  },
  {
    id: 1,
    image: {
      alt: 'CB Insights',
      src: 'product-accolades/cb-insights-color-logo',
      className: 'h-8',
    },
    content: 'accolades_cb_insights',
  },
  {
    id: 2,
    image: {
      alt: 'Real Simple',
      src: 'product-accolades/real-simple-color-logo',
      className: 'h-8',
    },
    content: 'accolades_real_simple',
  },
  {
    id: 3,
    image: {
      alt: 'Fast Company',
      src: 'product-accolades/fast-company-black-logo',
      className: 'h-16',
    },
    content: 'accolades_fast_company',
  },
];

const FitnessPressAccolades = () => {
  const t = useTranslations();

  return (
    <div className="bg-white">
      <div className="mx-6 flex max-w-(--breakpoint-xl) flex-col flex-wrap justify-center gap-8 py-10 md:flex-row md:gap-0 lg:py-20 xl:mx-auto">
        {ACCOLADES_DATA.map(({ id, image, content }) => (
          <div key={id} className="p-4 md:w-1/2 lg:w-1/4">
            <TypographyV3 Element="h3" className="mb-5 md:h-16">
              <Image
                src={image.src}
                className={`mx-auto w-auto ${image.className}`}
                alt={image.alt}
                loading="lazy"
                width="330"
                height="50"
                format="png"
              />
            </TypographyV3>
            <TypographyV3 align="center">{t(content)}</TypographyV3>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FitnessPressAccolades;
